import { Clock } from "lucide-react";

/** Grayed-out "Coming Soon" overlay for gated wellness features
 *  (step counter, rewards). Renders the underlying UI beneath a light
 *  grey opacity mask + a centered pill with a strikethrough label so
 *  users can still see what's coming without being able to interact. */
export default function ComingSoonOverlay({
  children,
  message = "Coming soon",
  detail,
  className = "",
  testid = "coming-soon-overlay",
}) {
  return (
    <div className={`relative ${className}`} data-testid={testid}>
      {/* Original UI, greyed and non-interactive */}
      <div className="opacity-40 grayscale pointer-events-none select-none" aria-hidden="true">
        {children}
      </div>

      {/* Overlay pill */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none p-4">
        <div className="pointer-events-auto inline-flex flex-col items-center gap-1.5 px-5 py-3.5 rounded-2xl bg-white/95 dark:bg-slate-900/95 backdrop-blur border border-slate-200 dark:border-slate-700 shadow-xl">
          <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400">
            <Clock className="w-4 h-4" />
            <span className="text-sm font-bold uppercase tracking-wide line-through decoration-slate-400 decoration-2">
              {message}
            </span>
          </div>
          {detail && (
            <p className="text-[11px] leading-snug text-slate-500 dark:text-slate-400 text-center max-w-[240px]">
              {detail}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
